var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"gz-header"},[_c('div',{staticClass:"gz-header__container gz-page__width"},[_c('GZ-Logo'),_c('gz-top-menu'),(_vm.$store.getters['authToken'])?_c('GZ-AuthMenu'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }